import api from '../api'
import { IPartner } from '../loadPartners'

export function updatePartner(partner: IPartner): Promise<Record<string, unknown>> {
    return api.put({ path: '/partners', body: partner })
}
